import { I18nTypes } from '@diagentech/exprworks-rule-engine';
import {
  ViolationBanner as ExprWorksViolationBanner,
  ViolationBannerProps as ExprWorksViolationBannerProps,
} from '@diagentech/exprworks-ui-components';
import React from 'react';

interface ViolationBannerProps extends Omit<ExprWorksViolationBannerProps, 'id'> {
  id?: I18nTypes | null;
}

export const ViolationBanner: React.FC<ViolationBannerProps> = ({ id, ...rest }) => (
  <ExprWorksViolationBanner id={id ?? 'SH.COMMON.ER.001'} {...rest} />
);
